import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function PostSidebar({categories,last_posts}:any) {
    return ( 
        <div className="col-lg-4">

            {/* <!-- Category Start --> */}
            <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                    <h3 className="mb-0">دسته بندی ها</h3>
                </div>
                <div className="link-animated d-flex flex-column justify-content-start">
                   {categories && categories.map((row:any,index:number) => 
                        <Link key={index} to={`/blog/${row.id}`} className="btn h5 fw-semi-bold bg-light rounded py-2 px-3 mb-2 text-start">
                            <FontAwesomeIcon icon="arrow-left" className="me-2"/>{row.name}
                        </Link>
                    )}
                </div>
            </div>
            {/* <!-- Category End --> */}

            {/* <!-- Recent Post Start --> */}
            <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                    <h3 className="mb-0">آخرین پست ها</h3>
                </div>
                {last_posts && last_posts.map((row:any,index:number) => 
                <div key={index} className="d-flex rounded overflow-hidden mb-3 ">
                    <img className="img-fluid" src={row.image} style={{width: "100px", height: "100px", objectFit: "cover"}} alt={row.title}/>
                    <Link to={`/post/${row.id}/${row.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`} className="h5 fw-semi-bold d-flex align-items-center bg-light px-3 mb-0" style={{minWidth:"80%"}}>{row.title}</Link>
                </div>)}
            </div>
            {/* <!-- Recent Post End --> */}

        </div>
     );
}

export default PostSidebar;